'use client';

import React from 'react';
import { reportClientError } from '@/lib/clienterr';

// Wraps the whole client tree so we capture React's componentStack (which names
// the offending component) for crashes we can't reproduce — e.g. the iOS-only
// hydration #310. Beacons the component stack, then shows a reload fallback.
export default class ClientErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    reportClientError('boundary', {
      message: (error && error.message) || String(error),
      // componentStack names the component tree — the key to identifying the bug.
      stack: (info && info.componentStack) || (error && error.stack) || '',
    } as unknown);
  }

  render() {
    if (this.state.failed) {
      return (
        <main
          style={{
            minHeight: '70dvh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            padding: '0 24px',
            textAlign: 'center',
          }}
        >
          <p style={{ fontSize: 16, fontWeight: 600 }}>頁面載入發生問題</p>
          <p style={{ fontSize: 14, color: '#71717a' }}>請重新載入,若持續發生請關閉 App 再開啟。</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              borderRadius: 12,
              border: 'none',
              background: '#10b981',
              color: '#fff',
              fontSize: 14,
              fontWeight: 600,
              padding: '10px 20px',
            }}
          >
            重新載入
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
